import React from 'react';
import { Paper , Slide} from '@material-ui/core';
import NotificationsTable from './NotificationsTable';
import { useHistory } from "react-router-dom";
import { Console } from 'console';
import './style.css';
import './Notifications.css';

const Notifications = () => {

    return (
        <Slide in timeout={800} direction="left">
            <div className="maincontent">
                    <NotificationsTable />
            </div>
            </Slide>
    );
}

export default Notifications;